import { ModuleWithProviders, NgModule } from '@angular/core';
import { IrisSiaService } from './sia.service';
import { IrisSiaSandbox } from './sia.sandbox';

@NgModule({
  imports: [],
})
export class IrisCommonSiaModule {
  static forRoot(): ModuleWithProviders<IrisCommonSiaModule> {
    return {
      ngModule: IrisCommonSiaModule,
      providers: [
        IrisSiaService,
        IrisSiaSandbox,
      ],
    };
  }
}
